// extracted by mini-css-extract-plugin
export default {"table":"index_table_zuXgK","bold":"index_bold_qaKcw","red":"index_red_lDf-f","mrgg":"index_mrgg_cW644","suspend":"index_suspend_MnhEU"};